const oldoptionHeight = {
    groupHeading: 36,
    user: 40,
    userDescription: 56,
    tag: 46,
    tagDescription: 56,
    basic: 36,
    allOptions: 56
};
const newoptionHeight = {
    groupHeading: 36,
    user: 32,
    userDescription: 56,
    tag: 46,
    tagDescription: 56,
    basic: 36,
    allOptions: 56
};
let cached = null;
const isNewUIEnabled = ()=>{
    if (cached === null) {
        if (typeof document === 'undefined') {
            return false;
        }
        cached = document.documentElement.hasAttribute('data-new-theme-enabled');
    }
    return cached;
};
export const optionHeight = newoptionHeight;
export const getOptionHeight = ()=>isNewUIEnabled() ? newoptionHeight : oldoptionHeight;
